var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.38,
    height: 13.722,
    viewBox: "0 0 15.38 13.722",
    fill: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning_black_24dp_2_",
    "data-name": "warning_black_24dp (2)",
    d: "M4.083,17.714h12.15a1.613,1.613,0,0,0,1.4-2.42L11.554,4.8a1.613,1.613,0,0,0-2.792,0l-6.075,10.5A1.613,1.613,0,0,0,4.083,17.714Zm6.075-5.648a.809.809,0,0,1-.807-.807V9.646a.807.807,0,1,1,1.614,0V11.26A.809.809,0,0,1,10.159,12.067Zm.807,3.227H9.352V13.68h1.614Z",
    transform: "translate(-2.469 -3.992)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantIcon);
export default __webpack_public_path__ + "static/media/ImportantIcon.8a23f56cfe0ef860c6a9eb40fc6d3f62.svg";
export { ForwardRef as ReactComponent };